/**
 * Serializes the provided object with its keys deeply sorted
 */
export function serializeWithSort(obj) {
    const allKeys = new Set();
    // The callback below will be called for every key-value pair (nested as well);
    // using this fact to create a set of all keys within the object
    JSON.stringify(obj, (key, value) => {
        allKeys.add(key);
        return value;
    });
    return JSON.stringify(obj, Array.from(allKeys).sort());
}
//# sourceMappingURL=serializeWithSort.js.map